module.exports = __webpack_public_path__ + "static/media/down-arrow.d51c4cbd.svg";